var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.compact)?_c('div',[_c('b-skeleton',{attrs:{"width":"20%"}})],1):_c('section',{staticClass:"section"},[_c('JSB'),(!_vm.logoLoaded)?_c('b-skeleton',{attrs:{"count":5}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }